// 设置 store — 别名、主题、STUN 服务器、设备指纹

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const ADJECTIVES = ['快乐的', '迅捷的', '神秘的', '勇敢的', '可爱的小'];
const ANIMALS = ['海豚', '飞鱼', '企鹅', '鲸鱼', '海鸥', '小船'];

export function generateDefaultAlias(): string {
  const a = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)];
  const n = ANIMALS[Math.floor(Math.random() * ANIMALS.length)];
  return `${a}${n}`;
}

export function generateDeviceToken(): string {
  return crypto.randomUUID();
}

interface SettingsState {
  alias: string;
  deviceToken: string;
  deviceId: string;
  theme: 'light' | 'dark';
  setAlias: (alias: string) => void;
  setTheme: (theme: 'light' | 'dark') => void;
  toggleTheme: () => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      alias: generateDefaultAlias(),
      deviceToken: generateDeviceToken(),
      deviceId: crypto.randomUUID(),
      theme: 'light',
      setAlias: (alias) => set({ alias }),
      setTheme: (theme) => set({ theme }),
      toggleTheme: () => set((s) => ({ theme: s.theme === 'light' ? 'dark' : 'light' })),
    }),
    { name: 'kuaichuan-settings' },
  ),
);
